import { render, staticRenderFns } from "./SelectFields.vue?vue&type=template&id=6edad228"
import script from "./SelectFields.vue?vue&type=script&lang=js"
export * from "./SelectFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports